// Import dependencies
import React from "react";
import {
  Card,
  CardActions,
  CardMedia,
  Button,
  Typography,
} from "@material-ui/core/";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
import { useDispatch } from "react-redux";

import { likePost, deletePost } from "../../../actions/posts";
import useStyles from "./styles";
import isImageUrl from "is-image-url";
import xmeme from "../../../images/xmeme.jpg";

// Post structure and design
const Post = ({ post, setCurrentId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.media}
        image={
          // Check if image is url or not
          isImageUrl(post.url) ? post.url : xmeme
          // post.url || xmeme
        }
        title={post.caption}
      />

      <div className={classes.overlay2}>
        <Typography variant="body2">
          {moment(post.createdAt).fromNow()}
        </Typography>
      </div>
      <div className={classes.details}>
        <Typography variant="body2" color="textSecondary" component="h3">
          {post.name}
        </Typography>
      </div>
      <Typography
        className={classes.title}
        gutterBottom
        variant="h5"
        component="h2"
      >
        {post.caption}
      </Typography>
      <CardActions className={classes.cardActions}>
        <Button
          size="small"
          color="primary"
          onClick={() => dispatch(likePost(post.id))}
        >
          <ThumbUpAltIcon fontSize="small" /> Like &nbsp;
          {post.likeCount}
        </Button>
        <Button
          size="small"
          color="primary"
          onClick={() => setCurrentId(post.id)}
        >
          <EditIcon fontSize="small" /> Edit
        </Button>
        <Button
          size="small"
          color="primary"
          onClick={() => dispatch(deletePost(post.id))}
        >
          <DeleteIcon fontSize="small" />
          Delete
        </Button>
      </CardActions>
    </Card>
  );
};

export default Post;
